// schwabbadge-20261104: Schwab account in the wallet slot on stock charts.
// Masked last-4 comes from the server (/stk/accounts); click cycles accounts.
// relayUp is App's existing /stk/status poll (stkRelayUp).
import { useState, useEffect } from 'react'

const BASE = import.meta.env.VITE_HTTP_PROXY_BASE || 'https://history.cheddarterminal.app'
const KEY = 'solcheddar:schwabAcct'

export default function SchwabAccountBadge({ relayUp }) {
  const [accts, setAccts] = useState([])
  const [idx, setIdx] = useState(() => +(localStorage.getItem(KEY) || 0) || 0)
  useEffect(() => {
    if (!relayUp || accts.length) return
    fetch(`${BASE}/stk/accounts`).then(r => r.json())
      .then(d => { if (Array.isArray(d)) setAccts(d) }).catch(() => {})
  }, [relayUp, accts.length])

  if (!relayUp || !accts.length) {
    return <button className="local-wallet-btn no-wallet" disabled title="Schwab relay offline">Schwab offline</button>
  }
  const i = idx % accts.length
  return (
    <button
      className="local-wallet-btn connected"
      onClick={() => { const n = (i + 1) % accts.length; setIdx(n); localStorage.setItem(KEY, String(n)) }}
      title={`Schwab ${accts[i].masked}\nClick to switch account (${i + 1}/${accts.length})`}
    >
      {accts[i].masked}
    </button>
  )
}
